module.exports = __webpack_public_path__ + "img/me.2b8ef821.svg";